import { cn } from "../../helpers"
import { paragraph } from "../typography"

const popoverContent = (className?: string) => cn("w-full p-0 sm:w-[27rem]", className)
const inputWrapper = cn("flex items-center gap-3 border-b border-neutral-200 p-3")
const searchIcon = cn("w-4 shrink-0 stroke-2 text-neutral-600")
const input = cn(
  paragraph({ size: "sm" }),
  "rounded-none border-none text-black outline-none placeholder:text-neutral-600 w-full scroll-mt-[100px]",
)

export { input, inputWrapper, popoverContent, searchIcon }
